import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { CL_MEDIA_LIABILITY_COVER, CYBER_LIABILITY_COVER, PROFESSIONAL_INDEMNITY } from '../../constants/coverage';
export var getAskRetroactiveDateQuestionAndDataMap = function getAskRetroactiveDateQuestionAndDataMap() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, CYBER_LIABILITY_COVER, {
    coverageText: 'Cyber',
    showHavePolicySection: true,
    pathKey: 'QuoteProcess_Hiscox_Ask_Retroactive_Date_Cyber_Liability',
    havePolicyDataKey: 'haveCyberInsurance',
    haveRetroactiveDateDataKey: 'cyberRetroactiveDateAvailable',
    retroactiveDateDataKey: 'cyberRetroactiveDate'
  }), _defineProperty(_ref, CL_MEDIA_LIABILITY_COVER, {
    coverageText: 'Media Liability',
    showHavePolicySection: false,
    pathKey: 'QuoteProcess_Hiscox_Ask_Retroactive_Date_Media_Liability',
    haveRetroactiveDateDataKey: 'mediaLiabilityRetroactiveDateAvailable',
    retroactiveDateDataKey: 'mediaLiabilityRetroactiveDate'
  }), _defineProperty(_ref, PROFESSIONAL_INDEMNITY, {
    coverageText: 'Professional Liability',
    showHavePolicySection: true,
    pathKey: 'QuoteProcess_Hiscox_Ask_Retroactive_Date_Professional_Indemnity',
    havePolicyDataKey: 'haveProfLiabilityInsurance',
    haveRetroactiveDateDataKey: 'professionalLiabilityRetroactiveDateAvailable',
    retroactiveDateDataKey: 'professionalLiabilityRetroactiveDate'
  }), _ref;
};